import PageLayout from 'pages/AssignmentEditor/PageLayout';
import PageProvider, { PageContext } from 'pages/AssignmentEditor/PageProvider';

const AssignmentEditorPage = (props) => (
    <PageProvider {...props}>
        <PageLayout {...props} pageContext={PageContext} />
    </PageProvider>
);

export default AssignmentEditorPage;
